import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OrganizationPreview = () => {
  // remove mock departments; encourage navigation to full structure page
  const departments = [];

  const container = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.12 } },
  };

  const item = {
    hidden: { y: 24, opacity: 0, scale: 0.98 },
    show: { y: 0, opacity: 1, scale: 1, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
  };

  return (
    <section className="py-12 lg:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-4">
            {"โครงสร้างองค์กร".split("").map((ch, i) => (
              <motion.span
                key={`org-title-${i}-${ch}`}
                style={{ display: 'inline-block' }}
                initial={{ y: 10, opacity: 0 }}
                whileInView={{ y: [10, -3, 0], opacity: 1 }}
                viewport={{ once: true, margin: '-20% 0px -10% 0px' }}
                transition={{ delay: 0.02 * i, duration: 0.6 }}
              >
                {ch}
              </motion.span>
            ))}
          </h2>
          <motion.p 
            className="text-muted-foreground text-lg max-w-2xl mx-auto"
            initial={{ y: 12, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            หน่วยงานหลักและผู้รับผิดชอบในที่ว่าการอำเภอเทิง
          </motion.p>
        </div>

        <motion.div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8" variants={container} initial="hidden" whileInView="show" viewport={{ once: true }}>
          {departments?.length === 0 && (
            <div className="col-span-1 lg:col-span-3 text-center text-muted-foreground">
              ยังไม่มีข้อมูลแสดงผล โปรดดูรายละเอียดที่หน้าโครงสร้างองค์กร
            </div>
          )}
          {departments?.map((dept) => (
            <motion.div
              key={dept?.id}
              className="bg-card rounded-lg p-6 shadow-government hover:shadow-government-lg transition-government"
              variants={item}
            >
              <div className="flex items-start space-x-4 mb-4">
                <div className={`w-12 h-12 rounded-lg ${dept?.bgColor} flex items-center justify-center flex-shrink-0`}>
                  <Icon name={dept?.icon} size={24} className={dept?.color} />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-foreground mb-2">
                    {dept?.name.split("").map((ch, idx) => (
                      <motion.span
                        key={`dept-${dept?.id}-n-${idx}`}
                        style={{ display: 'inline-block' }}
                        initial={{ y: 8, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.015 * idx, duration: 0.45 }}
                      >
                        {ch}
                      </motion.span>
                    ))}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {dept?.description.split(' ').map((w, wi) => (
                      <motion.span
                        key={`dept-${dept?.id}-d-${wi}`}
                        style={{ display: 'inline-block', marginRight: 4 }}
                        initial={{ y: 10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.02 * wi + 0.25, duration: 0.4 }}
                      >
                        {w}
                      </motion.span>
                    ))}
                  </p>
                </div>
              </div>

              <div className="border-t border-border pt-4">
                <div className="flex items-center space-x-3 mb-2">
                  <Icon name="User" size={16} className="text-muted-foreground" />
                  <div>
                    <p className="text-sm font-medium text-foreground">{dept?.head}</p>
                    <p className="text-xs text-muted-foreground">{dept?.position}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <Icon name="Phone" size={16} className="text-muted-foreground" />
                  <p className="text-sm text-foreground">{dept?.phone}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <div className="text-center">
          <Button
            variant="outline"
            iconName="Building2"
            iconPosition="left"
            asChild
          >
            <Link to="/organization-structure">
              ดูโครงสร้างองค์กรแบบละเอียด
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default OrganizationPreview;